import { all, takeEvery, call, put } from 'redux-saga/effects';
import * as ACTION from "../components/GlobalAddTriggerModal/actions/globalTriggerActionTypes";
import * as GLOBAL_TRIGGER_API from "../api/globalTriggerApi";
import { 
  addTriggerFailure, 
  addTriggerFolderFailure, 
  addTriggerFolderSuccess, 
  addTriggerSuccess, 
  deleteTriggerFailure, 
  deleteTriggerFolderFailure, 
  deleteTriggerFolderSuccess, 
  deleteTriggerSuccess, 
  duplicateTriggerFailure, 
  duplicateTriggerSuccess, 
  getTriggerFailure, 
  getTriggerFolderFailure, 
  getTriggerFolderSuccess, 
  getTriggerSuccess, 
  updateTriggerFailure, 
  updateTriggerFolderFailure, 
  updateTriggerFolderSuccess, 
  updateTriggerStatusFailure, 
  updateTriggerStatusSuccess, 
  updateTriggerSuccess,
 } from '../components/GlobalAddTriggerModal/actions/globalTriggerAction';
import Utils from '../helpers/Utils';


function* globalTriggerWatcher() {
    yield takeEvery(ACTION.ADD_TRIGGER_FOLDER, addTriggerFolderMiddleware);
    yield takeEvery(ACTION.GET_TRIGGER_FOLDER, getTriggerFolderMiddleware);
    yield takeEvery(ACTION.UPDATE_TRIGGER_FOLDER, updateTriggerFolderMiddleware);
    yield takeEvery(ACTION.DELETE_TRIGGER_FOLDER, deleteTriggerFolderMiddleware);
    yield takeEvery(ACTION.ADD_TRIGGER, addTriggerMiddleware);
    yield takeEvery(ACTION.GET_TRIGGER, getTriggerMiddleware);
    yield takeEvery(ACTION.UPDATE_TRIGGER, updateTriggerMiddleware);
    yield takeEvery (ACTION.DELETE_INSURANCE_TRIGGER, deleteTriggerMiddleware);
    yield takeEvery(ACTION.UPDATE_TRIGGER_STATUS, updateTriggerStatusMiddleware);
    yield takeEvery(ACTION.DUPLICATE_INSURANCE_TRIGGER, duplicateTriggerMiddleware);
}

function* addTriggerFolderMiddleware(action) {
    try {
      const response = yield call(
        GLOBAL_TRIGGER_API.addTriggerFolderApi,
        action.payload
      );
      if (response.success) {
        yield put(addTriggerFolderSuccess(response.data));
        window.showNotification("SUCCESS", response.message);
  
        if (action.payload && action.payload.callback) {
          action.payload.callback();
        }
      } else {
        yield put(addTriggerFolderFailure(response.message));
        window.showNotification("ERROR", response.message);
      }
    } catch (error) {
      yield put(addTriggerFolderFailure(error.message));
      window.showNotification("ERROR", error.message);
      Utils.handleException(error);
    }
  };

  function* getTriggerFolderMiddleware(action) {
    try {
      const response = yield call(
        GLOBAL_TRIGGER_API.getTriggerFolderApi,
        action.payload
      );
      if (response.success) {
        yield put(getTriggerFolderSuccess(response.data));
      } else {
        yield put(getTriggerFolderFailure(response.message));
        window.showNotification("ERROR", response.message);
      }
    } catch (error) {
      yield put(getTriggerFolderFailure(error.message));
      window.showNotification("ERROR", error.message);
      Utils.handleException(error);
    }
  };
  
  function* updateTriggerFolderMiddleware(action) {
    try {
      const response = yield call(
        GLOBAL_TRIGGER_API.updateTriggerFolderApi,
        action.payload
      );
      if (response.success) {
        yield put(updateTriggerFolderSuccess(action.payload));
        window.showNotification("SUCCESS", response.message);
  
        if (action.payload && action.payload.callback) {
          action.payload.callback();
        }
      } else {
        yield put(updateTriggerFolderFailure(response.message));
        window.showNotification("ERROR", response.message);
      }
    } catch (error) {
      yield put(updateTriggerFolderFailure(error.message));
      window.showNotification("ERROR", error.message);
      Utils.handleException(error);
    }
  };
  
  function* deleteTriggerFolderMiddleware(action) {
    try {
      const response = yield call(
        GLOBAL_TRIGGER_API.deleteTriggerFolderApi,
        {id: action.payload.id}
      );
      if (response.success) {
        yield put(deleteTriggerFolderSuccess({id: action.payload.id}));
        window.showNotification("SUCCESS", response.message);
  
        if (action.payload && action.payload.callback) {
          action.payload.callback();
        }
      } else {
        yield put(deleteTriggerFolderFailure(response.message));
        window.showNotification("ERROR", response.message);
      }
    } catch (error) {
      yield put(deleteTriggerFolderFailure(error.message));
      window.showNotification("ERROR", error.message);
      Utils.handleException(error);
    }
  };
  
  function* addTriggerMiddleware(action) {
    try {
      const response = yield call(
        GLOBAL_TRIGGER_API.addTriggerApi,
        action.payload
      );
      if (response.success) {
        yield put(addTriggerSuccess(response.data));
        window.showNotification("SUCCESS", response.message);
  
        if (action.payload && action.payload.callback) {
          action.payload.callback(response.data);
        }
      } else {
        yield put(addTriggerFailure(response.message));
        window.showNotification("ERROR", response.message);
      }
    } catch (error) {
      yield put(addTriggerFailure(error.message));
      window.showNotification("ERROR", error.message);
      Utils.handleException(error);
    }
  };

  function* getTriggerMiddleware(action) {
    try {
      const response = yield call(
        GLOBAL_TRIGGER_API.getTriggerApi,
        action.payload
      );
      if (response.success) {
        yield put(getTriggerSuccess(response.data));
  
      } else {
        yield put(getTriggerFailure(response.message));
        window.showNotification("ERROR", response.message);
      }
    } catch (error) {
      yield put(getTriggerFailure(error.message));
      window.showNotification("ERROR", error.message);
      Utils.handleException(error);
    }
  };

  function* updateTriggerMiddleware(action) {
    try {
      const response = yield call(
        GLOBAL_TRIGGER_API.updateTriggerApi,
        action.payload
      );
      if (response.success) {
        yield put(updateTriggerSuccess(action.payload));
        if (action.payload && action.payload.callback) {
          action.payload.callback();
        }
        window.showNotification("SUCCESS", response.message);
      } else {
        yield put(updateTriggerFailure(response.message));
        window.showNotification("ERROR", response.message);
      }
    } catch (error) {
      yield put(updateTriggerFailure(error.message));
      window.showNotification("ERROR", error.message);
      Utils.handleException(error);
    }
  };

  function* deleteTriggerMiddleware(action) {
    try {
      const response = yield call(
        GLOBAL_TRIGGER_API.deleteTriggerApi,
        {id: action.payload.id}
      );
      if (response.success) {
        yield put(deleteTriggerSuccess({id: action.payload.id}));
        window.showNotification("SUCCESS", response.message);
  
        if (action.payload && action.payload.callback) {
          action.payload.callback();
        }
      } else {
        yield put(deleteTriggerFailure(response.message));
        window.showNotification("ERROR", response.message);
      }
    } catch (error) {
      yield put(deleteTriggerFailure(error.message));
      window.showNotification("ERROR", error.message);
      Utils.handleException(error);
    }
  };

  function* updateTriggerStatusMiddleware(action) {
    try {
      const response = yield call(
        GLOBAL_TRIGGER_API.updateTriggerStatusApi,
        action.payload
      );
      if (response.success) {
        yield put(updateTriggerStatusSuccess(action.payload));
        if (action.payload && action.payload.callback) {
          action.payload.callback();
        }
        window.showNotification("SUCCESS", response.message);
      } else {
        yield put(updateTriggerStatusFailure(action.payload));
        window.showNotification("ERROR", response.message);
      }
    } catch (error) {
      yield put(updateTriggerStatusFailure(action.payload));
      window.showNotification("ERROR", error.message);
      Utils.handleException(error);
    }
  };

  function* duplicateTriggerMiddleware(action) {
    try {
      const response = yield call(
        GLOBAL_TRIGGER_API.duplicateTriggerApi,
        action.payload
      );
      if (response.success) {
        yield put(duplicateTriggerSuccess(response.data));
        if (action.payload && action.payload.callback) {
          action.payload.callback();
        }
        window.showNotification("SUCCESS", response.message);
  
      } else {
        yield put(duplicateTriggerFailure(response.message));
        window.showNotification("ERROR", response.message);
      }
    } catch (error) {
      yield put(duplicateTriggerFailure(error.message));
      window.showNotification("ERROR", error.message);
      Utils.handleException(error);
    }
  };

  

export default function* globalTriggerMiddleware() {
    yield all([
        globalTriggerWatcher()
    ])
}